import { render } from "./paymentDetails.vue?vue&type=template&id=6fefaa8c&scoped=true&ts=true"
import script from "./paymentDetails.vue?vue&type=script&lang=ts"
export * from "./paymentDetails.vue?vue&type=script&lang=ts"

import "./paymentDetails.vue?vue&type=style&index=0&id=6fefaa8c&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fefaa8c"]])

export default __exports__